/* RESPONSIBLE TEAM: team-reporting */

import { ChartDefinition, Timezone } from '@/features/report-snapshots/api/schema';
import { formatDateLabel, formatTimestamp } from '@/features/report-snapshots/formatters/timestamp';
import type { I18n } from '@lingui/core';
import {
  METRIC_DISPLAY_OVERRIDES,
  REPORTING_CONVERSATION_RATINGS,
} from '@/features/report-snapshots/constants';
import { ChartSeries } from '@/features/report-snapshots/components/charts/utils/chart-data';

export function getLabels(
  series: ChartSeries[],
  chartDefinition: ChartDefinition,
  timezone: Timezone,
  i18n: I18n,
): string[] {
  const labels = series[0].data.map((data) => data.name);

  const viewBy = chartDefinition.viewBy;

  if (Object.values(METRIC_DISPLAY_OVERRIDES).includes(viewBy as METRIC_DISPLAY_OVERRIDES)) {
    return labels.map((label) => {
      if (label in REPORTING_CONVERSATION_RATINGS) {
        return i18n._(
          REPORTING_CONVERSATION_RATINGS[label as keyof typeof REPORTING_CONVERSATION_RATINGS],
        );
      }
      return label;
    });
  }

  if (chartDefinition.viewByTimeInterval) {
    const interval = chartDefinition.viewByTimeInterval;
    return labels.map((label) =>
      typeof label === 'number' ? formatTimestamp(interval, label, timezone, i18n) : String(label),
    );
  }
  if (chartDefinition.viewBy === 'time') {
    return labels.map((label) =>
      typeof label === 'number' ? formatDateLabel(label) : String(label),
    );
  }
  return labels;
}
